module.exports = __webpack_public_path__ + "static/media/ProductSearch_003.35692041.png";